import jobIcon from '../../images/job-icon.png';
import toList from '../utils/ComponentUtil';
import Header from '../utils/Header';
import DailyJobCard from './DailyJobCard';
import "./DailyJobsDesc.scss"

function DailyJobsDesc() {
    const jobs = [{
        title: "Review Writing Jobs",
        subject: "Read and write the review about the given content.",
        price: "Rs. 10/",
        perUnit: "per each copy proof reading job",
        to: '/internships/custom/review-writing',
        img: jobIcon
    },{
        title: "Copy Paste Jobs",
        subject: "Simply copy paste the given ad content.",
        price: "Rs. 2/",
        perUnit: "per each copy proof reading job",
        to: '/internships/custom/copy-paste',
        img: jobIcon
    },{
        title: "Proof Reading",
        subject: "Check the Grammar and Edit the mispelled words.",
        price: "Rs. 10/",
        perUnit: "per each copy proof reading job",
        to: '/internships/custom/new-proof-reading',
        img: jobIcon
    }];

    return (
        <div className="daily-jobs-wrp wrapper">
            <Header title='Daily Jobs' subTitle='These are simple jobs Available daily. Any user can do this jobs easily and Earn decent Income regularly.'></Header>
            <div className="jobs-container">
                {toList(jobs, DailyJobCard)}
            </div>
        </div>
    );
}

export default DailyJobsDesc;